import CustomBizEmojiMessage from "./CustomBizEmojiMessage";
import CustomTopicPostMessage from "./CustomTopicPostMessage";
import CustomNameCardMessage from "./CustomNameCardMessage";
import CustomCompanyCardMessage from "./CustomCompanyCardMessage";
import CustomProductMessage from "./CustomProductMessage";
import CustomMeetupMessage from "./CustomMeetupMessage";
import CustomForwardMessage from "./CustomForwardMessage";
import CustomDataSyncMessage from "./CustomDataSyncMessage";
import CustomChatRoomStatusMessage from "./CustomChatRoomStatusMessage";
export var CustomMessagesPlugin = {
  name: "FhtCustomMessages",
  // beforeMessageDispatch(message: AVMessage) {
  //     IS_DEV && console.log("before message dispatch", message);
  //     return true;
  // },
  // afterMessageParse: (m: AVMessage) => {
  //     IS_DEV && console.log("after Message parse", m);
  //     return m;
  // },
  messageClasses: [CustomBizEmojiMessage, CustomTopicPostMessage, CustomNameCardMessage, CustomCompanyCardMessage, CustomProductMessage, CustomMeetupMessage, CustomForwardMessage, CustomDataSyncMessage, CustomChatRoomStatusMessage]
};